import Axios from '@/services/axios-instance/axios.service';

class ApplicationService {
  async createApplication(req) {
    const { data } = await Axios.post('/application/create', req);
    return data;
  }
  async getApplicationDetails(req) {
    const { data } = await Axios.post('/application/details', req);
    return data;
  }
  async updateApplicationDetails(req) {
    const { data } = await Axios.post('/application/details-update', req);
    return data;
  }
  async getApplicationShortDetails(req) {
    const { data } = await Axios.post('/application/details-short', req);
    return data;
  }
  async updateApplicationShortDetails(req) {
    const { data } = await Axios.post('/application/details-short-update', req);
    return data;
  }
  async bankVerification(req) {
    const { data } = await Axios.post('/application/bank-validation', req);
    return data;
  }
}

export default new ApplicationService();
